import type { FlagsStateContainer } from '@confluence/flags';

import type { IntegrationMap } from './integration-service-types';
import { useLoomService } from './useLoomService';

const integrationsMap: IntegrationMap = {};

export const useIntegrationService = (
	flags: FlagsStateContainer,
	contentId: string,
	contentStatus: string | null,
) => {
	const loomService = useLoomService(flags, contentId, contentStatus);

	integrationsMap['loom'] = {
		integration: loomService.triggerIntegration,
		isAvailable: loomService.isAvailable,
	};

	const triggerIntegration = ({
		id,
		onSuccess,
		onFailure,
		otherProps,
	}: {
		id: keyof typeof integrationsMap;
		onSuccess: (args: unknown) => void;
		onFailure?: (args: unknown) => void;
		otherProps: unknown;
	}) =>
		integrationsMap[id]
			? integrationsMap[id]!.integration({ onSuccess, onFailure, otherProps })
			: Promise.reject('No integration found');
	const checkIntegration = ({ id }: { id: keyof typeof integrationsMap }) =>
		integrationsMap[id]?.isAvailable() || false;

	return { triggerIntegration, checkIntegration };
};

export type integrationService = ReturnType<typeof useIntegrationService>;
